import core from '@gin-betting/core';

import type { ModuleLocator } from 'async-modules';

const {
    services: { moduleLocator },
} = core;

export default moduleLocator as ModuleLocator;
